import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";

const ItemScoreOverviewChart = (props) => {
    const overviewData = props?.overviewData;
    const top5Data = props?.top5Data;
    const bottom5Data = props?.bottom5Data;
    const competitorData = props?.competitorData;
    const [ ownTopItemScore, setOwnTopItemScore ] = useState(0);
    const [ competitorTopItemScore, setCompetitorTopItemScore ] = useState(0);
    const [ ownBottomItemScore, setOwnBottomItemScore ] = useState(0);
    const [ competitorBottomItemScore, setCompetitorBottomItemScore ] = useState(0);
    const [ ownAverageItemScore, setOwnAverageItemScore ] = useState(0);
    const [ overallAverageItemScore, setOverallAverageItemScore ] = useState(0);

    useEffect(() => {
        if(overviewData) {
            setOwnAverageItemScore(overviewData?.ownAverage);
            setOverallAverageItemScore(overviewData?.overallAverage);
        }
    }, [overviewData])

    useEffect(() => {
        if(top5Data && competitorData) {
            setOwnTopItemScore(top5Data[0]?.item_score);
            setCompetitorTopItemScore(competitorData[0]?.item_score);
        }
    }, [top5Data, competitorData])

    useEffect(() => {
        if(bottom5Data && competitorData) {
            setOwnBottomItemScore(bottom5Data[0]?.item_score);
            setCompetitorBottomItemScore(competitorData[competitorData.length - 1]?.item_score);
        }
    }, [bottom5Data, competitorData])

    const chartScale = () => {
        const ticks = [];
        for(let i = 0; i <= 40; i++) {
            if (i % 2 === 0) {
                ticks.push(<Col className="p-0" style={{alignContent: 'center', width: '2.5%'}}>
                                <Row style={{justifySelf: 'center'}}>
                                    <Col>
                                        <div style={{height: '10px', width: '1px', background: 'black'}}></div>
                                    </Col>
                                </Row>
                                <Row className="my-1" style={{textAlign: 'center'}}>
                                    <Col>
                                        <div style={{fontSize: '10px'}}>{(i*5)/2}</div>
                                    </Col>
                                </Row>
                            </Col>);
            }
            else {
                ticks.push(<Col className="p-0" style={{width: '2.5%'}}>
                                <Row style={{justifySelf: 'center'}}>
                                    <Col>
                                        <div style={{height: '5px', width: '1px', background: 'black'}}></div>
                                    </Col>
                                </Row>
                            </Col>);
            }
        }
        return ticks;
    }

    const bottomItems = (ownBottomScore, competitorBottomScore) => {
        const ownLowerThanCompetitor = ownBottomScore < competitorBottomScore;
        const topLimit = ownBottomScore >= competitorBottomScore ? ownBottomScore : competitorBottomScore;
        const bottomLimit = ownBottomScore < competitorBottomScore ? ownBottomScore : competitorBottomScore;
        const chartScaleWidth = document.getElementById('itemScoreOverviewChartScale')?.offsetWidth * 0.975;
        return (
            <Row className="mx-0" style={{position: 'relative', top: '-3px',left: `calc(${((chartScaleWidth / 100) * bottomLimit)}px)`}}>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanCompetitor ? '#C10D0D' : '#FF7A00'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
                <Col className="w-fc px-0 my-auto">
                    <div style={{background: 'white', height: '4px', width: `calc(${((chartScaleWidth / 100) * (topLimit-bottomLimit)) - 9}px)`, transform: 'translate(-5px)'}}></div>
                </Col>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanCompetitor ? '#FF7A00' : '#C10D0D'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
            </Row>
        )
    }

    const averageItems = (ownAverageScore, overallAverageScore) => {
        const ownLowerThanOverall = ownAverageScore < overallAverageScore;
        const topLimit = ownAverageScore >= overallAverageScore ? ownAverageScore : overallAverageScore;
        const bottomLimit = ownAverageScore < overallAverageScore ? ownAverageScore : overallAverageScore;
        const chartScaleWidth = document.getElementById('itemScoreOverviewChartScale')?.offsetWidth * 0.975;
        return (
            <Row className="mx-0" style={{position: 'relative', top: '-3px',left: `calc(${((chartScaleWidth / 100) * bottomLimit)}px)`}}>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanOverall ? '#0B9402' : '#0B4807'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
                <Col className="w-fc px-0 my-auto">
                    <div style={{background: 'white', height: '4px', width: `calc(${((chartScaleWidth / 100) * (topLimit-bottomLimit)) - 9}px)`, transform: 'translate(-5px)'}}></div>
                </Col>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanOverall ? '#0B4807' : '#0B9402'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
            </Row>
        )
    }

    const topItems = (ownTopScore, competitorTopScore) => {
        const ownLowerThanCompetitor = ownTopScore < competitorTopScore;
        const topLimit = ownTopScore >= competitorTopScore ? ownTopScore : competitorTopScore;
        const bottomLimit = ownTopScore < competitorTopScore ? ownTopScore : competitorTopScore;
        const chartScaleWidth = document.getElementById('itemScoreOverviewChartScale')?.offsetWidth * 0.975;
        return (
            <Row className="mx-0" style={{position: 'relative', top: '-3px',left: `calc(${((chartScaleWidth / 100) * bottomLimit)}px)`}}>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanCompetitor ? '#49A4DA' : '#006099'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
                <Col className="w-fc px-0 my-auto">
                    <div style={{background: 'white', height: '4px', width: `calc(${((chartScaleWidth / 100) * (topLimit-bottomLimit)) - 9}px)`, transform: 'translate(-5px)'}}></div>
                </Col>
                <Col className="w-fc mx-0 px-0" style={{transform: 'translate(-50%)'}}>
                    <div style={{height: '63px', width: '9px', background: (ownLowerThanCompetitor ? '#006099' : '#49A4DA'), borderRadius: '8px', border: '1px solid white'}}></div>
                </Col>
            </Row>
        )
    }

    return (
        <Col>
            <Row>
                <Col className='w-fc' style={{fontWeight: 'bold', fontSize: '12px'}}>
                    Losing
                </Col>
                <Col>
                </Col>
                <Col className='w-fc' style={{fontWeight: 'bold', fontSize: '12px'}}>
                    Winning
                </Col>
            </Row>
            <Row>
                <Col>
                    <div id='itemScoreOverviewChartScale'>
                        <div style={{width: '98.75%', paddingLeft: '1.25%'}}>
                            <Col className="w-fc" style={{position: 'absolute'}}>
                                {bottomItems(ownBottomItemScore, competitorBottomItemScore)}
                            </Col>
                            <Col className="w-fc" style={{position: 'absolute'}}>
                                {averageItems(ownAverageItemScore, overallAverageItemScore)}
                            </Col>  
                            <Col className="w-fc" style={{position: 'absolute'}}>
                                {topItems(ownTopItemScore, competitorTopItemScore)}
                            </Col>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Row id='itemScoreOverviewChartArea' className="mx-0" style={{justifyContent: 'space-between'}}>
                        {chartScale()}
                    </Row>
                </Col>
            </Row>
        </Col>
    )
}

export default ItemScoreOverviewChart;